import React from "react";
import { Award, MapPin, Users, Zap } from "lucide-react";
import { INDUSTRIES } from "../../mock";

export default function About() {
  const points = [
    {
      icon: Users,
      title: "Small team, senior talent",
      body: "No account managers, no juniors learning on your budget. You work directly with the people building your product.",
    },
    {
      icon: Zap,
      title: "Fast, predictable delivery",
      body: "Weekly demos, transparent timelines and fixed-quote pricing. You always know exactly where the project stands.",
    },
    {
      icon: MapPin,
      title: "Based in Lanarkshire, working UK-wide",
      body: "Proudly Scottish. We meet local clients in person and run remote workshops with teams across the UK and beyond.",
    },
    {
      icon: Award,
      title: "Built for the long run",
      body: "We're picky about projects because we want to be your partner for years — not just the team that built the first version.",
    },
  ];

  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="section-eyebrow">About the studio</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.05]">
              Your local Lanarkshire social media manager &amp; web designer.
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed">
              Andy Watson IT is a Lanarkshire-based studio built to help
              ambitious local businesses grow through smart web design,
              social media management, social media marketing and digital
              marketing. Founded here in Lanarkshire, still hands-on with
              every project — no big-agency overhead, no juniors learning
              on your budget.
            </p>

            <div className="mt-8 relative aspect-[4/3] rounded-3xl overflow-hidden border border-slate-200">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80"
                alt="Andy Watson IT team collaborating on a digital project in Lanarkshire"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {points.map((p) => (
                <div
                  key={p.title}
                  className="rounded-2xl border border-slate-200 p-6 card-lift bg-white hover:border-sky-200"
                >
                  <div className="h-10 w-10 rounded-xl bg-sky-50 flex items-center justify-center mb-4">
                    <p.icon className="h-5 w-5 text-sky-700" />
                  </div>
                  <h3 className="font-semibold text-slate-900">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-10 rounded-3xl border border-slate-200 p-8 bg-slate-50">
              <div className="text-xs uppercase tracking-[0.2em] text-sky-600 font-semibold">
                Industries we serve
              </div>
              <div className="mt-5 flex flex-wrap gap-2">
                {INDUSTRIES.map((i) => (
                  <span
                    key={i}
                    className="px-3.5 py-1.5 rounded-full bg-white border border-slate-200 hover:border-sky-300 hover:text-sky-700 transition-colors text-sm text-slate-700"
                  >
                    {i}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
